import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { useUser } from '../context/UserContext';

const flagImages = {
  fr: 'https://flagcdn.com/w40/fr.png',
  en: 'https://flagcdn.com/w40/gb.png',
  es: 'https://flagcdn.com/w40/es.png',
  pt: 'https://flagcdn.com/w40/br.png'
};

const Navbar = () => {
  const { lang, setLang, t, langNames } = useLanguage();
  const { user, loading } = useUser();
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const menuRef = useRef();

  useEffect(() => {
    const handleClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) setMenuOpen(false);
    };
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);

  const getAvatarUrl = () => {
    if (user?.avatar && user?.discord_id) {
      return `https://cdn.discordapp.com/avatars/${user.discord_id}/${user.avatar}.png`;
    }
    if (user?.avatar && user?.google_id) {
      return user.avatar;
    }
    return null;
  };

  return (
    <nav className="navbar">
      <Link to="/" className="logo">Elite<span>Bet</span></Link>
      
      <div className="nav-center">
        <Link to="/" className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}>{t('home')}</Link>
        <Link to="/leaderboard" className={`nav-link ${location.pathname === '/leaderboard' ? 'active' : ''}`}>{t('leaderboard')}</Link>
      </div>
      
      <div className="nav-actions">
        <div className="lang-selector" ref={menuRef}>
          <button className="lang-btn" onClick={() => setMenuOpen(!menuOpen)}>
            <img src={flagImages[lang]} alt={lang} className="lang-flag-img" />
            <span className="lang-arrow">▼</span>
          </button>
          {menuOpen && (
            <div className="lang-menu">
              {Object.keys(flagImages).map((l) => (
                <button 
                  key={l} 
                  className={`lang-option ${l === lang ? 'active' : ''}`} 
                  onClick={() => { setLang(l); setMenuOpen(false); }}
                >
                  <img src={flagImages[l]} alt={l} className="lang-option-flag-img" />
                  <span className="lang-option-name">{langNames[l]}</span>
                </button>
              ))}
            </div>
          )}
        </div>

        {loading ? (
          <div className="nav-user-loading">...</div>
        ) : user ? (
          <button className="nav-user-btn" onClick={() => navigate('/profile')}>
            {getAvatarUrl() ? (
              <img src={getAvatarUrl()} alt="" className="nav-user-avatar" />
            ) : (
              <div className="nav-user-avatar-placeholder">👤</div>
            )}
            <span className="nav-user-name">{user.username}</span>
            <span className="nav-user-points">💰 {user.points.toLocaleString()}</span>
          </button>
        ) : (
          <Link to="/login" className="login-btn">{t('login')}</Link>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
